<main #trendingContainer class="container-fluid trending-container cinema-section" *ngIf="isLoading || (similarTvSeriesData && similarTvSeriesData.length)">
    <section #trendingHeader class="d-flex align-items-center flex-row my-2 cinema-section-header">
        <section id="trendingHeader" class="my-2 cinema-title-shell">
            <div class="d-flex align-items-center cinema-title-group">
                <h3 class="heading-text mb-0 cinema-section-title">{{ languageService.t('similar') || 'Similar Like This' }}</h3>
            </div>
        </section>
    </section>

    <div class="my-3 skeleton-container cinema-skeleton" *ngIf="isLoading">
        <div class="trending-movie-container skeleton-card-item" *ngFor="let _ of initialSkeletons">
            <app-card-skeleton [mediaType]="'tv'"></app-card-skeleton>
        </div>
    </div>

    <div *ngIf="similarTvSeriesData && similarTvSeriesData.length && !isLoading" class="trending-wrapper">

        <div class="smoke-effect smoke-left" *ngIf="canScrollLeft" [@fadeIn]></div>

        <button 
            class="scroll-btn scroll-btn-left" 
            *ngIf="!isMobile && canScrollLeft" 
            (click)="scrollLeft()" 
            [@fadeIn]>
            <i class="text-white fa-solid fa-arrow-left"></i>
        </button>

        <section #movieSection class="my-3 trending-movie-section" (scroll)="checkScrollPosition()">
            <div *ngFor="let movie of similarTvSeriesData; let i = index" class="trending-movie-container" [@fadeIn]>
                <app-media-card
                    [data]="movie"
                    [mediaType]="'tv'"
                    [priority]="i < 2">
                </app-media-card>
            </div>
        </section>

        <button 
            class="scroll-btn scroll-btn-right" 
            *ngIf="!isMobile && canScrollRight" 
            (click)="scrollRight()" 
            [@fadeIn]>
            <i class="text-white fa-solid fa-arrow-right"></i>
        </button>

        <div class="smoke-effect smoke-right" *ngIf="canScrollRight" [@fadeIn]></div>
    </div>
</main>